<template>
    <setting-card
        v-bind="binds"
        :dialogBind="dialogBind"
        :width="dialogWidth"
        :closeOnValid="false"
        v-model:active="localActive"
        :comingSoon="comingSoon"
        :disableConfiguration="disableConfiguration"
        :hidePrevious="false"
        @close="resetWizard()"
        @previous="resetWizard()"
        @updateProfile="updateProfile()"
        :dense="dense"
        :displayDeleteBtn="true"
        @delete="onDeleteClicked"
        @onActive="onActiveChange()"
    >
        <template v-slot:sub-text>
            <div class="text-disabled text-caption">
                <template v-if="lastImportDateFormated">
                    Dernier import : {{ lastImportDateFormated }}
                </template>
            </div>
            <oss-dialog
                v-model="openDeleteDialog"
                title="Supprimer un connecteur"
                @valid="handleDeletion"
                :error="true"
                @close="openDeleteDialog = false"
                width="600px"
            >
                <div class="text-center" v-if="!name || name.length === 0">
                    &#xca;tes-vous sûr de vouloir supprimer ce connecteur ?
                </div>
                <div class="text-center" v-else>
                    &#xca;tes-vous sûr de vouloir supprimer le connecteur "{{ name }}" ?
                </div>
            </oss-dialog>
        </template>

        <v-row no-gutters style="min-width: 650px">
            <v-col>
                <v-window v-model="wizardStep">
                    <v-window-item :value="'authentication'">
                        <v-row no-gutters class="d-flex justify-center">
                            <v-col class="pa-2 border-right flex-grow-1 flex-shrink-0">
                                <h3>Authentification</h3>
                                <div v-if="inputs && inputs.length">
                                    <v-text-field-filled
                                        v-for="(input, key) of inputs"
                                        :key="key"
                                        v-model="authValues[input.key]"
                                        hide-details
                                        outlined
                                        autocomplete="off"
                                        class="pa-2"
                                        :label="input.label"
                                        density="compact"
                                    />
                                </div>
                                <div v-else class="d-flex justify-center pa-2">
                                    <v-btn
                                        class="pa-2 mt-2"
                                        rounded
                                        elevation="0"
                                        @click="getConsumerConnectionUrl()"
                                        size="small"
                                    >
                                        Se connecter
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col class="flex-grow-0 flex-shrink-1 px-2">
                                <div
                                    style="
                                        height: 100px;
                                        width: 1px;
                                        background-color: lightgrey;
                                        margin: 0 10px;
                                    "
                                />
                            </v-col>
                            <v-col class="pa-2 flex-grow-1 flex-shrink-0">
                                <h3>Options</h3>
                                <ossDatePicker-filled
                                    v-model="datePickerFormat"
                                    :readonly="datePickerReadOnly"
                                    class="pa-2"
                                    :persistent-hint="true"
                                    label="Date de reprise"
                                    :textFieldReadOnly="datePickerReadOnly"
                                    :hint="datePickerHint"
                                />
                                <template v-if="allOptions && allOptions.length">
                                    <div v-for="option in allOptions" :key="option.key">
                                        <template v-if="option.type === 'boolean'">
                                            <v-switch
                                                v-model="optionsValues[option.key]"
                                                :label="option.label"
                                                hide-details
                                            />
                                        </template>
                                        <template v-if="option.type === 'select'">
                                            <v-select-filled
                                                v-model="optionsValues[option.key]"
                                                :label="option.label"
                                                :items="option.items"
                                                hide-details
                                                class="mt-2"
                                                density="compact"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </v-col>
                        </v-row>
                        <v-row no gutters>
                            <v-col>
                                <v-card-actions class="pa-2">
                                    <div class="text-disabled text-caption d-flex align-end">
                                        {{
                                            lastImportDateFormated
                                                ? "Dernier import : " + lastImportDateFormated
                                                : ""
                                        }}
                                    </div>
                                    <v-spacer />
                                    <v-btn-icon
                                        icon="$fa-gear"
                                        v-if="displayImportMapping"
                                        id="config"
                                        size="small"
                                        @click="wizardStep = 'importMapping'"
                                    />
                                    <v-btn-icon
                                        icon="$oss-sync"
                                        v-if="enableSync"
                                        class="mr-2"
                                        @click="wizardStep = 'refetch-connector'"
                                        size="small"
                                    />
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <v-window-item v-if="accountableAccountMapping" :value="'importMapping'">
                        <SettingConnectorImportMapping
                            v-model:import-mapping="data.accountingMapping"
                            :companyId="companyId"
                            @accountChange="updateProfile"
                        />
                    </v-window-item>
                    <v-window-item :value="'refetch-connector'">
                        <SettingConnectorRefetchData
                            :connectorId="id"
                            :companyId="companyId"
                            :origin="origin"
                            :application="application"
                            :externalId="externalId"
                        />
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
    </setting-card>
</template>

<script lang="ts">
import GET_CONSUMER_CONNECTION_URL from "../../../graphql/connector/GetConsumerConnectionUrl.gql";
import GET_CONNECTOR_ADDITIONAL_DATA from "../../../graphql/connector/GetConnectorAdditionalData.gql";
import STATUS_CONNECTOR from "../../../graphql/connector/StatusConnector.gql";

import SettingCard from "../SettingCard.vue";
import ImportMapping from "../../ImportMapping.vue";

import moment from "moment-timezone";
import { getDBFormattedDate } from "../../../services/dateServices";
import SettingConnectorRefetchData from "./components/SettingConnectorRefetchData.vue";
import SettingConnectorImportMapping from "./components/SettingConnectorImportMapping.vue";

import DELETE_CONNECTOR from "@/graphql/connector/DeleteConnector.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        SettingCard,
        ImportMapping,
        SettingConnectorRefetchData,
        SettingConnectorImportMapping,
    },
    emits: ["updateProfile", "connector-deleted"],
})
export class SettingConnector extends Vue {
    // @Prop({ default: null }) connectorConfig: any
    @Prop({ default: "" }) name: string;
    @Prop({ default: "" }) origin: string;
    @Prop({ default: "" }) application: string;
    @Prop({ default: "" }) externalId: string;
    @Prop({ default: "" }) type!: string;
    @Prop({ default: null }) companyId!: string;
    @Prop({ default: null }) logo: any;

    @Model({ name: "startImportDate" }) syncedStartImportDate: Date;
    @Prop({ default: null }) lastImportDate: Date;
    @Prop({ default: null }) currentError: string;
    @Prop({ default: null }) status!: string;
    @Prop() inputs: SettingConnectorInput[];
    @Prop({ default: false }) active: boolean;
    @Prop({ default: false }) comingSoon: boolean;
    @Prop({ default: false }) enableSync: boolean;

    @Model({ default: null, name: "options" }) options_: any[];
    @Prop({ default: null }) data: any;
    @Prop({ default: false }) additionalData: boolean;
    @Prop({ default: null }) id: string;
    @Prop({ default: false }) disableConfiguration: boolean;
    @Prop({ default: false }) dense: boolean; // Show a compact version of the UI

    wizardStep = "authentication";
    loadAdditionalData = false;
    additionalOptions = [];

    authValues: Record<string, string> = {};
    optionsValues: Record<string, boolean> = {};

    currentAdditionalDataQuery: AbortController | null = null;

    openDeleteDialog = false;

    localActive: boolean = false;

    beforeMount() {
        if (this.additionalData) {
            this.$watch("authValues", this.onAuthValuesChange, { deep: true, immediate: true });
        }
        this.localActive = this.active;
    }

    get binds() {
        return {
            title: this.name,
            partnerName: "",
            text: this.getText(),
            logo: this.logo,
        };
    }

    get importBinds() {
        return {
            origin: this.origin,
            application: this.application,
        };
    }

    get accountableAccountMapping() {
        if (
            this.origin === "CHIFT_POS" ||
            (this.origin === "CHIFT" && this.type === "POINT_OF_SALE")
        ) {
            return true;
        }
        return false;
    }

    get dialogBind() {
        return {
            "previous-display": this.wizardStep !== "authentication",
            "hide-valid": this.wizardStep !== "authentication" || !this.inputs?.length,
        };
    }

    get windowItem() {
        if (this.accountableAccountMapping) {
            return ["authentication", "importMapping"];
        } else {
            return ["authentication"];
        }
    }

    get displayImportMapping() {
        return !!this.accountableAccountMapping;
    }

    get dialogWidth() {
        if (this.wizardStep === "importMapping") {
            return "80%";
        } else {
            return "60%";
        }
    }

    get datePickerFormat() {
        return moment(this.syncedStartImportDate).format();
    }

    set datePickerFormat(value) {
        this.syncedStartImportDate = moment(value).toDate();
    }

    get formatedDate() {
        return moment(this.syncedStartImportDate).format("DD MMMM YYYY à hh:mm");
    }

    get lastImportDateFormated() {
        // debugger;
        if (!this.lastImportDate) {
            return "";
        }
        return moment(this.lastImportDate).format("DD MMMM YYYY à HH:mm");
    }

    // get closeOnValid() {
    //     if (this.wizardStep !== "authentication") {
    //         return true
    //     }
    //     return false
    // }

    get configValue() {
        return {
            id: "",
            company: this.companyId,
            name: "",
            origin: this.origin,
            application: this.application,
            importMode: "WEBHOOK",
            date: moment(this.syncedStartImportDate).format(),
            data: {
                authentication: this.authValues,
                options: this.optionsValues,
                accountingMapping: this.data?.accountingMapping || undefined,
            },
            status: this.status,
            customerId: "",
            currentError: "",
            lastImportDate: this.lastImportDate,
        };
    }

    get allOptions() {
        const result = [];
        if (this.options_ && this.options_.length) {
            result.push(...this.options_);
        }
        if (this.additionalOptions && this.additionalOptions.length) {
            result.push(...this.additionalOptions);
        }
        return result;
    }

    get datePickerReadOnly() {
        if (this.origin === "POWENS") {
            return true;
        }
        return false;
    }

    get datePickerHint() {
        if (this.origin === "POWENS") {
            return "La date de reprise ne peut être modifiée";
        }
        return "";
    }

    resetWizard() {
        this.wizardStep = "authentication";
    }

    async updateProfile() {
        if (!this.localActive) {
            return;
        }
        this.$emit("updateProfile", this.configValue);
        // await this.onActiveChange()
    }

    getText() {
        switch (this.application) {
            case "Finthesis":
                return "Envoyez vos données comptables directement sur votre compte Finthesis";
            default:
                break;
        }

        // DEFAULT TEXT DESCRITPION
        switch (this.type) {
            case "POINT_OF_SALE":
                return "Récupérer vos Z de caisse en vous conenctant à votre logiciel de caisse";
            case "E-COMMERCE":
                return "Récupérer vos ventes en vous connectant à vote site e-commerce";
            case "INVOICING":
                return "Récupérer vos factures de vente en vous connectant à votre logiciel de facturation";
            case "INVOICE":
                return "Récupérer vos factures d'achats en vous connectant au site de votre fournisseur";
            default:
                return "";
        }
    }

    get importMapping() {
        return [];
    }

    @Watch("inputs", { immediate: true, deep: true })
    onInputsChange() {
        if (this.inputs?.length) {
            this.authValues = this.inputs.reduce(
                (acc, curr) => ({
                    ...acc,
                    [curr.key]: this.data?.authentication?.[curr.key] || "",
                }),
                {},
            );
        }

        if (this.options_?.length) {
            this.optionsValues = this.options_.reduce(
                (acc, curr) => ({
                    ...acc,
                    [curr.key]: this.data?.options?.[curr.key] || false,
                }),
                {},
            );
        }
    }

    async getConsumerConnectionUrl() {
        debugger;
        const consumerConnectionUrl = await this.$apollo.query({
            query: GET_CONSUMER_CONNECTION_URL,
            variables: {
                integratorId: this.externalId.toString(),
                companyId: this.companyId,
                origin: this.origin,
                type: this.type,
                application: this.application,
                syncedStartImportDate: this.datePickerFormat,
            },
        });

        if (consumerConnectionUrl) {
            window.location.href = consumerConnectionUrl.data.getConsumerConnectionUrl.url;
        }
    }

    async onAuthValuesChange() {
        this.loadAdditionalData = true;

        if (this.currentAdditionalDataQuery) {
            this.currentAdditionalDataQuery.abort();
        }

        this.currentAdditionalDataQuery = new AbortController();
        const { signal } = this.currentAdditionalDataQuery;
        try {
            const additionalData = await this.$apollo.query({
                query: GET_CONNECTOR_ADDITIONAL_DATA,
                fetchPolicy: "network-only",
                variables: {
                    companyId: this.companyId,
                    origin: this.origin,
                    application: this.application,
                    externalId: this.externalId.toString(),
                    authentication: this.authValues,
                },
                context: {
                    fetchOptions: {
                        signal,
                    },
                },
            });
            if (additionalData?.data?.getConnectorAdditionalData?.additionalData) {
                this.additionalOptions =
                    additionalData.data.getConnectorAdditionalData.additionalData;
            }
        } catch (error) {
            console.error(error);
        }
        this.loadAdditionalData = false;
    }

    @Watch("active")
    onActivePropUpdated() {
        this.localActive = this.active;
    }

    async onActiveChange() {
        const response = await this.$apollo.mutate({
            mutation: STATUS_CONNECTOR,
            variables: {
                companyId: this.companyId,
                origin: this.origin,
                application: this.application,
                isActive: this.localActive, // Whether user chooses to activate the connection or not
            },
        });
    }

    closeConfigDialog = null; // References the callback to close the main configuration dialog once deletion is complete

    onDeleteClicked(closeConfigDialog) {
        this.openDeleteDialog = true;
        this.closeConfigDialog = closeConfigDialog;
    }

    async handleDeletion() {
        const response = await this.$apollo.mutate({
            mutation: DELETE_CONNECTOR,
            variables: {
                id: this.id,
                companyId: this.companyId,
            },
        });
        if (response.data.deleteConnector.success) {
            this.openDeleteDialog = false;
            this.$emit("connector-deleted", this.id);
            if (this.closeConfigDialog) {
                this.closeConfigDialog();
            }
        }
    }
}

type SettingConnectorInput = {
    label: string;
    key: string;
    value?: string;
};

export default toNative(SettingConnector);
</script>
